import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidPlayIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18.5 9 8.9 3.5C8.4 3.2 7.8 3 7.2 3 5.3 3 3.8 4.5 3.8 6.4v11.2c0 1.9 1.5 3.4 3.4 3.4.6 0 1.2-.2 1.7-.5l9.7-5.6c.5-.3.9-.7 1.2-1.2.9-1.6.4-3.7-1.3-4.7Z"/>
  </SvgIcon>
}

export default SolidPlayIcon
